webpackJsonp([87192162464282],{

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _questionModule = __webpack_require__(336);
	
	var _questionModule2 = _interopRequireDefault(_questionModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Question = function Question(props) {
	  var answer = props.answer,
	      questionLine1 = props.questionLine1,
	      questionLine2 = props.questionLine2;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: _questionModule2.default.questionContainer },
	    _react2.default.createElement(
	      'div',
	      { className: _questionModule2.default.question },
	      questionLine1
	    ),
	    questionLine2 && _react2.default.createElement(
	      'div',
	      { className: _questionModule2.default.question },
	      questionLine2
	    ),
	    _react2.default.createElement('div', {
	      className: _questionModule2.default.answer,
	      dangerouslySetInnerHTML: { __html: answer } // eslint-disable-line react/no-danger
	    })
	  );
	};
	
	exports.default = Question;
	module.exports = exports['default'];

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Question = __webpack_require__(227);
	
	var _Question2 = _interopRequireDefault(_Question);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Question2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"questionContainer":"src-components-Question----question-module---questionContainer---2QVov","question":"src-components-Question----question-module---question---1JHZS","answer":"src-components-Question----question-module---answer---82ddm"};

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"button":"src-components-buttons-Button----button-module---button---21K-3"};

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(16);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _buttonModule = __webpack_require__(93);
	
	var _buttonModule2 = _interopRequireDefault(_buttonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cx = _classnames2.default.bind(_buttonModule2.default);
	
	var Button = function Button(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      onClick = _ref.onClick,
	      url = _ref.url;
	
	  var buttonClasses = cx(_buttonModule2.default.button, className);
	
	  if (url) {
	    return _react2.default.createElement(
	      'a',
	      { className: buttonClasses, href: url },
	      children
	    );
	  } else {
	    return _react2.default.createElement(
	      'button',
	      { className: buttonClasses, onClick: onClick },
	      children
	    );
	  }
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/faq-image.31215f17.svg";

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(70);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactResponsive = __webpack_require__(37);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _Button = __webpack_require__(73);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Footer = __webpack_require__(51);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(52);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _MobileHeader = __webpack_require__(53);
	
	var _MobileHeader2 = _interopRequireDefault(_MobileHeader);
	
	var _Question = __webpack_require__(228);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _faqModule = __webpack_require__(349);
	
	var _faqModule2 = _interopRequireDefault(_faqModule);
	
	var _constants = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var questions = [{
	  questionLine1: 'When does the conference start on May 31st?',
	  questionLine2: 'When does it end on June 1st?',
	  answer: 'On the first day, there will be check-ins and breakfast starting at 8:00 AM. Open remarks begin at 9:00 AM, and the first presentation will begin around 10:00 AM. The conference portion of the day will end around 4:30 PM, when people can make their way to the after-hours event, which will begin at 5:00 PM. On June 1st, presentations will be complete at noon, and our Community Day will commence after lunch, and wrap up at 4:00 PM.'
	}, {
	  questionLine1: 'Is breakfast provided? What about lunch and dinner?',
	  answer: 'We will provide a light breakfast on both days at 8:00 AM until 9:00 AM. We also provide a full lunch and snack throughout the day. Coffee, tea, and water are served throughout both conference days. Food and drink will be served at the after-hours social event at <a href="http://www.schroederssf.com/" target="_blank">Schroder\'s Restaurant</a>.'
	}, {
	  questionLine1: 'Are there any ticket discounts available?',
	  answer: 'In addition to our Early Bird special (Ends March 31st), we offer a group discount for those purchasing 5-10 tickets at once. No code is necessary for this, just choose that option when registering.'
	}, {
	  questionLine1: 'Can I buy a ticket for just one day?',
	  answer: 'No, tickets can only be purchased for the whole conference at once.'
	}, {
	  questionLine1: 'Will this event be recorded?',
	  answer: 'Yes. The presentations as well as portions of the community day will be recorded and shared after the event.'
	}, {
	  questionLine1: 'Will there be a live stream of the event?',
	  answer: 'No. There will not be a live stream of the event, but we will be posting recordings of the talks as well as interesting content from the community day after the event.'
	}, {
	  questionLine1: 'Will you have any tutorial or workshop-only days?',
	  answer: 'We will feature a Community Day that will be similar to a workshop style session at QueryCon2018. This will occur in the afternoon on the second day.'
	}, {
	  questionLine1: 'Should I bring a laptop?',
	  answer: 'While you will not need a laptop during the talks, we are holding a Community Workshop in the afternoon of the second day of the conference. This time will be used for hands-on activities, learning, networking, and collaborating with folks in the community. Bring your laptop if you want to participate!'
	}, {
	  questionLine1: 'How far away is the conference venue from the airport?',
	  answer: 'Approximately 20 miles from the airport, in San Francisco’s Marina/Presidio district.'
	}, {
	  questionLine1: 'Is parking available at the venue?',
	  answer: 'There is <a href="https://www.google.com/maps/place/Parking+Area/@37.8062268,-122.4484005,18.54z/data=!4m12!1m6!3m5!1s0x808586d4bce240b9:0x3e7cf9a5c17c2c57!2sLittle+Marina+Green+Picnic+Area!8m2!3d37.805771!4d-122.4479267!3m4!1s0x808586d35950766d:0xade0d65df8f7410!8m2!3d37.8065216!4d-122.4477419" target="_blank">a free parking lot</a> in the Little Marina Green picnic area (right next to the venue)'
	}, {
	  questionLine1: 'Can I sponsor this conference?',
	  answer: 'We are not accepting any sponsors.'
	}, {
	  questionLine1: 'Can I submit a talk about a commercial product?',
	  answer: 'No, our goal is to ensure all talks center around open-source tools that attendees can easily utilize all of the available tools and software discussed in our speaker’s presentations. Please refrain from submitting talks that advertise, demo or heavily discuss any Osquery commercial offerings.'
	}, {
	  questionLine1: 'Is this an official Facebook conference?',
	  answer: 'While core members of Facebook’s Osquery team are attending and giving great talks, the conference is organized by Kolide, Inc.'
	}, {
	  questionLine1: 'Do you offer refunds for tickets?',
	  answer: 'No. We do not offer partial or full refunds for tickets.'
	}];
	
	var FAQ = function (_Component) {
	  _inherits(FAQ, _Component);
	
	  function FAQ() {
	    _classCallCheck(this, FAQ);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  FAQ.prototype.componentDidMount = function componentDidMount() {
	    this.node.scrollTop = 0;
	  };
	
	  FAQ.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { ref: function ref(node) {
	          return _this2.node = node;
	        } },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'QueryCon18 - FAQs'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'Frequently Asked Questions' })
	      ),
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { minWidth: _constants.DESKTOP_MIN_WIDTH },
	        _react2.default.createElement(_Header2.default, { dark: true })
	      ),
	      _react2.default.createElement(
	        _reactResponsive2.default,
	        { maxWidth: _constants.MOBILE_WIDTH },
	        _react2.default.createElement(_MobileHeader2.default, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _faqModule2.default.heroSection },
	        _react2.default.createElement(
	          'div',
	          { className: _faqModule2.default.header },
	          'Frequently Asked Questions'
	        ),
	        _react2.default.createElement('img', { alt: '', className: _faqModule2.default.heroImage, src: __webpack_require__(494) }),
	        _react2.default.createElement(
	          'div',
	          { className: _faqModule2.default.contactUsBar },
	          _react2.default.createElement(
	            'span',
	            { className: _faqModule2.default.contactUsContent },
	            "Don't",
	            ' see your question below? ',
	            "Don't",
	            ' hesitate to reach out:'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              url: 'mailto:info@querycon.io',
	              className: _faqModule2.default.contactUsButton
	            },
	            'Contact Us'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _faqModule2.default.questions },
	        questions.map(function (question) {
	          return _react2.default.createElement(_Question2.default, {
	            answer: question.answer,
	            key: question.questionLine1.replace(/\s/g, ''),
	            questionLine1: question.questionLine1,
	            questionLine2: question.questionLine2
	          });
	        })
	      ),
	      _react2.default.createElement('div', { className: _faqModule2.default.borderBottom }),
	      _react2.default.createElement(
	        'div',
	        { className: _faqModule2.default.contactUsContainer },
	        _react2.default.createElement('img', {
	          alt: '',
	          className: _faqModule2.default.bottomImage,
	          src: __webpack_require__(49)
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _faqModule2.default.bottomText },
	          _react2.default.createElement(
	            'div',
	            null,
	            'Still have questions about QueryCon?'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            "Don't",
	            ' hesitate to reach out and ask!'
	          )
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { url: 'mailto:info@querycon.io', className: _faqModule2.default.bottomButton },
	          'Contact Us'
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return FAQ;
	}(_react.Component);
	
	exports.default = FAQ;
	module.exports = exports['default'];

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"heroSection":"src-pages----faq-module---heroSection---LHOTx","header":"src-pages----faq-module---header---3fkgG","heroImage":"src-pages----faq-module---heroImage---3TpU3","contactUsBar":"src-pages----faq-module---contactUsBar---wvkut","contactUsContent":"src-pages----faq-module---contactUsContent---1dmSA","contactUsButton":"src-pages----faq-module---contactUsButton---3_mZd","questions":"src-pages----faq-module---questions---1thMr","borderBottom":"src-pages----faq-module---borderBottom---20paO","contactUsContainer":"src-pages----faq-module---contactUsContainer---TyfW7","bottomImage":"src-pages----faq-module---bottomImage---3kXrI","bottomText":"src-pages----faq-module---bottomText---kYsZD","bottomButton":"src-pages----faq-module---bottomButton---3dTCB"};

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-faq-js-1607894168e525808048.js